import script from "./StudentReview.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentReview.vue?vue&type=script&setup=true&lang=js"

import "./StudentReview.vue?vue&type=style&index=0&id=4cb945f3&lang=css"
import "./StudentReview.vue?vue&type=style&index=1&id=4cb945f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cb945f3"]])

export default __exports__